<template>
  <div
    v-if="tableTabs && tableTabs.length"
    class="student-consequences-ladder-datatable-container"
  >
    <ActionPanel
      v-if="tableTabs"
      @tab-clicked="setActiveTab"
      class="mb-3"
      :tabs="tableTabs"
    >
    </ActionPanel>
    <DataTable
      v-if="activeLadder"
      :class="{
        'hide-table-body': shouldHideTableBody
      }"
      :tbody-hidden="shouldHideTableBody"
      :items="activeLadderSteps || []"
      :fields="tableFields"
    >
      <template #order="{ item }">
        <td v-if="getStepByGradeYear(item)">{{ item.order }}</td>
      </template>
      <template #type="{ item }">
        <td v-if="getStepByGradeYear(item)">
          <!-- replace with real data -->
          {{ item.action ? item.action.name : item.type }}
          <!-- {{ item.action && item.action.name ? item.action.name : item.type }} -->
        </td>
      </template>
      <template #footer>
        <tfoot>
          <tr class="w-full border-top-1">
            <td colspan="3">
              {{ $t("common.reset_date") }}:
              {{ activeLadder.reset_dates[0] }}
            </td>
          </tr>
        </tfoot>
      </template>
      <template #no-items-view><div></div></template>
    </DataTable>
  </div>
</template>

<script>
import ActionPanel from "@/v3components/shared/DataTable/ActionPanel.vue"
import DataTable from "@/v3components/shared/DataTable/DataTable.vue"
import { computed, onMounted, reactive } from "vue"
import { useI18n } from "vue-i18n"
import { useStore } from "vuex"

export default {
  name: "StudentConsequencesLadderTable",
  components: { ActionPanel, DataTable },
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const state = reactive({
      activeTab: null
    })

    const user = computed(() => store.getters["authentication/user"])

    // Ladders
    const ladders = computed(() => store.getters["consequencesLadder/ladders"])
    const ladderTypes = computed(
      () => store.getters["consequencesLadder/ladderTypes"]
    )
    const activeLadder = computed(() => {
      return ladders.value && state.activeTab
        ? ladders.value[state.activeTab.value]
        : null
    })

    const activeLadderSteps = computed(() => {
      const steps =
        activeLadder.value && activeLadder.value.steps
          ? activeLadder.value.steps
          : []
      const userGradeYear = user.value.grade_year

      const groupedByOrder = steps.reduce((item, step) => {
        if (!item[step.order]) item[step.order] = []
        item[step.order].push(step)
        return item
      }, {})

      const filteredSteps = Object.values(groupedByOrder).flatMap((group) => {
        const stepsWithUserGradeYear = group.filter(
          (step) => step.action && step.action.grad_year === userGradeYear
        )
        if (stepsWithUserGradeYear.length > 0) {
          return stepsWithUserGradeYear
        } else {
          return group[0]
        }
      })

      return filteredSteps
    })

    const shouldHideTableBody = computed(() => {
      const steps = activeLadderSteps.value
      return (
        !!activeLadder.value &&
        (!steps || (Array.isArray(steps) && steps.length === 0))
      )
    })

    const getAllLadders = () => {
      store.dispatch("consequencesLadder/getAllLadders")
    }

    const tableTabs = computed(() =>
      ladderTypes.value
        ? ladderTypes.value.map((el) => {
            return {
              label: el == "both" ? t("common.combined_lts_ltc") : el,
              value: el
            }
          })
        : null
    )
    const tableFields = computed(() => [
      {
        key: "order",
        label: t("common.infraction_step"),
        sorter: false,
        filter: false
      },
      {
        key: "type",
        label: t("common.action_type"),
        sorter: false,
        filter: false
      }
    ])
    const setActiveTab = (tab) => {
      state.activeTab = tab
    }

    onMounted(() => {
      getAllLadders()
    })

    const getStepByGradeYear = (item) => {
      let step = false
      const gradYear = item.action ? item.action.grad_years : null
      if (
        gradYear == null ||
        (gradYear != null && gradYear.includes(user.value.grade_year))
      ) {
        step = true
      }
      return step
    }
    return {
      state,
      tableTabs,
      setActiveTab,
      activeLadderSteps,
      activeLadder,
      shouldHideTableBody,
      tableFields,
      getStepByGradeYear
    }
  }
}
</script>

<style></style>
